import businessApi from '@/services/calls/business'

export const useFetchBusinesses = () => {
  const businessStore = useBusinessStore()

  const fetchBusinesses = async (page: number = 1, append: boolean = false) => {
    try {
      const response = await businessApi.getBusinesses(page)
      if (append && businessStore.businesses) {
        businessStore.businesses = {
          ...response,
          results: [...businessStore.businesses.results, ...response.results],
        }
      } else {
        businessStore.businesses = response
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchBusiness = async (businessId: number) => {
    try {
      const response = await businessApi.getBusiness(businessId)
      businessStore.selectedBusiness = response
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAllBusinesses = async () => {
    try {
      // Fetch first page
      const firstPageResponse = await businessApi.getBusinesses(1)
      businessStore.businesses = firstPageResponse

      let currentPage = 1
      let hasNextPage = firstPageResponse.next !== null

      // Continue fetching remaining pages
      while (hasNextPage) {
        currentPage++
        const response = await businessApi.getBusinesses(currentPage)

        if (businessStore.businesses && response.results.length > 0) {
          businessStore.businesses = {
            ...response,
            results: [...businessStore.businesses.results, ...response.results],
          }
        }

        hasNextPage = response.next !== null
      }
    } catch (error) {
      console.log(error)
    }
  }

  return {
    fetchBusinesses,
    fetchBusiness,
    fetchAllBusinesses,
  }
}
